export default __webpack_public_path__ + "static/media/BillingStub.a61269da.svg";